import React from "react";
import "./style.css";

const History = () => {
  return (
    <div className="bg-img w-full flex justify-start items-center">
      <div className=" w-full h-[600px] max-w-screen-2xl mx-auto flex justify-between">
        <div className="mt-24">
          <h2 className=" text-white text-5xl font-normal leading-relaxed tracking-wide">
            History of
          </h2>
          <h1 className="text-white text-7xl font-semibold tracking-wide">
            Chiangmai
          </h1>
          <hr className="mt-3 border-2 bg-white  w-[400px] " />
          <h3 className="text-white text-3xl font-normal tracking-wider mt-3">
            ประวัติจังหวัดเชียงใหม่
          </h3>
        </div>

        <div className="self-center max-w-2xl text-white font-normal">
          <p className="indent-8 p-4 text-xl">
            เมืองเชียงใหม่ มีชื่อที่ปรากฏในตำนานว่า "นพบุรีศรีนครพิงค์เชียงใหม่"
            เป็นราชธานีของอาณาจักรล้านนาไทยมาตั้งแต่พระยามังรายได้ทรงสร้างขึ้น
            เมื่อ พ.ศ.1839 ซึ่งมี อายุครบ 710 ปี ในปี พ.ศ.2549
            และเมืองเชียงใหม่ได้มีวิวัฒนาการ สืบเนื่องกันมาในประวัติศาสตร์ตลอดมา
            เชียงใหม่มีฐานะเป็นนครหลวงอิสระ ปกครองโดยกษัตริย์ราชวงศ์มังราย
            ประมาณ 261 ปี (ระหว่าง พ.ศ.1839-2100) ในปี พ.ศ.2101
            เชียงใหม่ได้เสียเอกราชให้แก่กษัตริย์พม่าชื่อบุเรงนอง
            และได้ตกอยู่ภายใต้การปกครองของพม่านานร่วมสองร้อยปี
            จนถึงสมัยพระบาทสมเด็จพระเจ้าตากสินมหาราช
            และพระบาทสมเด็จพระพุทธยอดฟ้าจุฬาโลกมหาราช
            ได้ทรงช่วยเหลือล้านนาไทยภายใต้การนำของพระยากาวิละและพระยาจ่าบ้านในการทำสงครามขับไล่พม่าออกไปจากเชียงใหม่และเมืองเชียงแสนได้สำเร็จ
          </p>
          <p className="indent-8 text-xl p-4">
            พระบาทสมเด็จพระพุทธยอดฟ้าจุฬาโลกมหาราชสถาปนาพระยากาวิละเป็นเจ้าเมืองเชียงใหม่
            ในฐานะเมืองประเทศราชของกรุงเทพมหานคร และมีเชื้อสายของพระยากาวิละ
            ซึ่งเรียกว่า ตระกูลเจ้าเจ็ดตน ปกครองเมืองเชียงใหม่
            เมืองลำพูนและลาปางสืบต่อมาจนกระทั่งในรัชสมัยของ
            พระบาทสมเด็จพระจุลจอมเกล้าเจ้าอยู่หัวฯ ได้โปรดให้ปฏิรูปการปกครอง
            หัวเมืองประเทศราช ได้ยกเลิกการมีเมืองประเทศราชในภาคเหนือ
            จัดตั้งการปกครองแบบ มณฑลเทศาภิบาล เรียกว่า มณฑลพายัพ และเมื่อปี
            พ.ศ.2476
            พระบาทสมเด็จพระปกเกล้าเจ้าอยู่หัวได้ปรับปรุงการปกครองเป็นแบบจังหวัด
            เชียงใหม่จึงมีฐานะเป็นจังหวัดจนถึงปัจจุบัน
          </p>
        </div>
      </div>
    </div>
  );
};

export default History;
